import { render, staticRenderFns } from "./MoreMenuItemDefault.vue?vue&type=template&id=89af0636&scoped=true&"
import script from "./MoreMenuItemDefault.vue?vue&type=script&lang=ts&"
export * from "./MoreMenuItemDefault.vue?vue&type=script&lang=ts&"
import style0 from "./MoreMenuItemDefault.vue?vue&type=style&index=0&id=89af0636&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89af0636",
  null
  
)

export default component.exports